import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Cell, Checkbox, Text } from 'wix-style-react';
import StatusAlertSmall from 'wix-ui-icons-common/StatusAlertSmall';
import { Brands } from '../../../../enums';
import s from '../../RequestCall.scss';
import { FormContext } from './FormContext';
import { withInjectedRootStore, RootStore } from '../../../../providers';

interface DisclaimerProps extends InjectedExperimentsProps {
  rootStore: RootStore;
  disclaimerKey: string;
}

const DisclaimerComp: React.FC<DisclaimerProps> = ({
  rootStore,
  disclaimerKey,
}) => {
  const {
    values: formValues,
    handleChange,
    errors: validationErrors,
  } = React.useContext(FormContext);
  const { brand } = rootStore.appStore.appContext;
  const { t } = useTranslation();
  return (
    <Cell span={12}>
      <div className={classNames(s.disclaimerWrapper, s.column)}>
        <div className={s.disclaimerWrapper}>
          <div className={s.disclaimerCheckbox}>
            <Checkbox
              id='checkbox'
              dataHook='disclaimer-checkbox'
              hasError={!!validationErrors.checkbox}
              onChange={handleChange}
              checked={formValues.checkbox}
            />
          </div>
          <div>
            <Text as='div' size='tiny' weight='thin'>
              <Trans
                i18nKey={disclaimerKey}
                values={{
                  brand: brand === Brands.EDITOR_X ? 'Editor X' : 'Wix',
                }}
              >
                disclaimer text
                <a target='_blank' href='//www.wix.com/about/privacy'>
                  Privacy link
                </a>
              </Trans>
            </Text>
            <div
              className={classNames({ [s.hidden]: !validationErrors.checkbox })}
            >
              {/* {validationErrors.checkbox && ( */}
              <Box
                color='R10'
                align='left'
                verticalAlign='middle'
                marginTop='6px'
              >
                <StatusAlertSmall />
                <Text
                  as='div'
                  size='tiny'
                  skin='error'
                  className={s.checkboxError}
                  dataHook='checkbox-error-msg'
                >
                  {t(validationErrors.checkbox)}
                </Text>
              </Box>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </Cell>
  );
};

export const Disclaimer = withExperiments(
  withInjectedRootStore(DisclaimerComp),
);
